export const config = {
  BACKEND_SERVER_URL: import.meta.env.VITE_APP_BACKEND_ADDRESS,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_APP_GOOGLE_CLIENT_ID,
  LINKEDIN_LOGIN_URL: import.meta.env.VITE_LINKEDIN_LOGIN_URL,
  SITE_KEY: import.meta.env.VITE_APP_SITE_KEY,
  ENABLE_CAPTCHA: import.meta.env.MODE === 'production',
  FEATURES: {
    AUTH_ENABLED: import.meta.env.VITE_APP_AUTH_ENABLED
  }
};
